import { CircularProgress, CircularProgressProps } from '@mui/material';

export const MHMLoadingIcon: React.FC<CircularProgressProps> = (
  props: CircularProgressProps,
) => {
  return <CircularProgress color="primary" {...props} />;
};
